var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative mb-11"},[_c('work-findings',{attrs:{"cardTitle":"Work Findings"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }